var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22.6182,
    r: 21.75,
    stroke: "#5865F2",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8035 28.8192C19.8625 28.724 19.9068 28.6142 19.9807 28.5409C24.5736 23.9783 29.174 19.4156 33.767 14.853C33.9737 14.6479 34.1879 14.4722 34.5054 14.4722C34.8968 14.4722 35.1774 14.6333 35.3472 14.9848C35.517 15.329 35.458 15.6586 35.2143 15.9589C35.17 16.0175 35.1109 16.0687 35.0592 16.12C30.2004 20.939 25.3342 25.7653 20.468 30.5915C20.2465 30.8113 20.0102 30.9943 19.6927 30.9284C19.4638 30.8845 19.2053 30.782 19.0429 30.6208C16.9827 28.5995 14.9299 26.5562 12.8845 24.5202C12.4783 24.1174 12.4636 23.5755 12.8401 23.202C13.2167 22.8285 13.7558 22.8431 14.1693 23.2532C15.9415 25.0109 17.7137 26.7686 19.4859 28.5263C19.5598 28.5995 19.6188 28.702 19.6853 28.7899C19.7148 28.8046 19.7591 28.8119 19.8035 28.8192Z",
    fill: "#5865F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a0d9093c2dc203b02536275635f36809.svg";
export { ForwardRef as ReactComponent };